import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function KitSection() {
  return <div className="space-y-24 px-6 py-20" data-id="element-33">
      {/* SECTION 5 - What's Included with value anchoring */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeInUp} className="max-w-2xl mx-auto" data-id="element-34">
        <h2 className="font-serif text-3xl md:text-4xl text-[#E8E0D4] mb-4 text-center" data-id="element-35">
          Qué incluye el kit
        </h2>
        <p className="text-[#9B9285] text-center mb-10 text-sm" data-id="element-36">
          (sin relleno, sin teoría innecesaria — solo lo que funciona a las 3am)
        </p>

        <div className="bg-[#1A1815] rounded-xl p-8 border border-[#C4956A]/10 shadow-2xl shadow-black/50" data-id="element-37">
          <ul className="space-y-5" data-id="element-38">
            {[{
            item: 'PDF de 35 páginas en español (neutral)',
            value: 'Valor: $15'
          }, {
            item: 'Protocolo imprimible de 10 minutos',
            value: 'Valor: $10'
          }, {
            item: 'Tracker de 7 días (plantilla + ejemplo)',
            value: 'Valor: $8'
          }, {
            item: 'Reassurance Detox de 7 días (calendario)',
            value: 'Valor: $8'
          }].map((entry, i) => <li key={i} className="flex items-start text-[#E8E0D4] text-lg" data-id="element-39">
                <CheckIcon className="w-6 h-6 text-[#C4956A] mr-4 flex-shrink-0 mt-0.5" data-id="element-40" />
                <div className="flex-1" data-id="element-41">
                  <span data-id="element-42">{entry.item}</span>
                  <span className="text-[#9B9285]/50 text-sm ml-2 line-through" data-id="element-43">
                    {entry.value}
                  </span>
                </div>
              </li>)}

            <li className="flex items-start text-[#E8E0D4] text-lg" data-id="element-44">
              <CheckIcon className="w-6 h-6 text-[#C4956A] mr-4 flex-shrink-0 mt-0.5" data-id="element-45" />
              <div data-id="element-46">
                <span className="block mb-2" data-id="element-47">
                  Guiones listos para:{' '}
                  <span className="text-[#9B9285]/50 text-sm line-through ml-2" data-id="element-48">
                    Valor: $12
                  </span>
                </span>
                <ul className="pl-6 space-y-2 text-[#9B9285] text-base list-disc marker:text-[#C4956A]" data-id="element-49">
                  <li data-id="element-50">no confesar en caliente</li>
                  <li data-id="element-51">hablar con tu pareja sin empeorar todo</li>
                  <li data-id="element-52">pedir ayuda clínica con claridad</li>
                </ul>
              </div>
            </li>
          </ul>

          {/* Value anchor summary */}
          <div className="mt-8 pt-6 border-t border-[#C4956A]/10 text-center" data-id="element-53">
            <p className="text-[#9B9285] text-sm mb-1" data-id="element-54">
              Valor total: <span className="line-through" data-id="element-55">$53</span>
            </p>
            <p className="text-[#E8E0D4] text-2xl font-serif" data-id="element-56">
              Hoy: <span className="text-[#C4956A] font-bold" data-id="element-57">$6.36</span>
            </p>
            <p className="text-[#9B9285]/60 text-xs mt-2" data-id="element-58">
              Menos de lo que cuesta el café que te tomas para sobrevivir la
              mañana después de no dormir.
            </p>
          </div>
        </div>
      </motion.section>

      {/* SECTION 6 - Who it's for */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeInUp} className="max-w-2xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-59">
        <div data-id="element-60">
          <h3 className="font-serif text-2xl text-[#E8E0D4] mb-6 flex items-center" data-id="element-61">
            <span className="w-8 h-px bg-[#C4956A] mr-4" data-id="element-62"></span>
            Es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-63">
            {['la duda llega como alarma', 'te atrapa la rumiación', 'haces cosas para calmarte y luego vuelve peor', 'no quieres destruir tu paz (ni tu relación) por una noche de pánico'].map((item, i) => <li key={i} className="flex items-start text-[#9B9285]" data-id="element-64">
                <CheckIcon className="w-5 h-5 text-[#C4956A] mr-3 flex-shrink-0 mt-0.5" data-id="element-65" />
                <span data-id="element-66">{item}</span>
              </li>)}
          </ul>
        </div>

        <div data-id="element-67">
          <h3 className="font-serif text-2xl text-[#9B9285] mb-6 flex items-center" data-id="element-68">
            <span className="w-8 h-px bg-[#9B9285] mr-4" data-id="element-69"></span>
            No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-70">
            {['buscas que alguien decida por ti', 'estás en una relación peligrosa (prioriza seguridad y ayuda especializada)'].map((item, i) => <li key={i} className="flex items-start text-[#9B9285]/70" data-id="element-71">
                <XIcon className="w-5 h-5 text-[#9B9285] mr-3 flex-shrink-0 mt-0.5" data-id="element-72" />
                <span data-id="element-73">{item}</span>
              </li>)}
          </ul>
        </div>
      </motion.section>

      {/* SECTION 7 - Promise — more visceral */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeInUp} className="max-w-2xl mx-auto text-center" data-id="element-74">
        <h2 className="font-serif text-3xl md:text-4xl text-[#E8E0D4] mb-4" data-id="element-75">
          La promesa realista
        </h2>
        <p className="text-[#9B9285] text-sm mb-10" data-id="element-76">
          No te prometo que desaparezca. Te prometo que vas a saber qué hacer
          cuando llegue.
        </p>

        <p className="text-[#9B9285] text-lg mb-8" data-id="element-77">
          En 7 días no necesitas "certeza total".
          <br data-id="element-78" />
          Necesitas esto:
        </p>

        <div className="space-y-4 max-w-md mx-auto text-left mb-10" data-id="element-79">
          {[{
          before: 'Espiral de 3 horas',
          after: 'Episodio de 20 minutos'
        }, {
          before: 'Googlear hasta las 4am',
          after: 'Protocolo de 10 min y a dormir'
        }, {
          before: 'Confesar para calmarte',
          after: 'Reconocer el loop y no alimentarlo'
        }, {
          before: 'Culpa por existir',
          after: 'Compasión por estar aprendiendo'
        }].map((row, i) => <div key={i} className="flex items-center gap-4 text-sm md:text-base" data-id="element-80">
              <span className="flex-1 text-[#9B9285] line-through decoration-[#9B9285]/30 text-right" data-id="element-81">
                {row.before}
              </span>
              <span className="text-[#C4956A] flex-shrink-0" data-id="element-82">→</span>
              <span className="flex-1 text-[#E8E0D4] font-medium" data-id="element-83">
                {row.after}
              </span>
            </div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-3" data-id="element-84">
          {['menos compulsión', 'menos duración del episodio', 'más regreso al presente', 'más sueño posible', 'menos culpa por existir'].map((item, i) => <span key={i} className="px-4 py-2 rounded-full border border-[#C4956A]/20 bg-[#C4956A]/5 text-[#E8E0D4] text-sm md:text-base" data-id="element-85">
              {item}
            </span>)}
        </div>
      </motion.section>
    </div>;
}